export const PAYMENT_TYPE = {
    PREPAY: "prepay",
    FINAL: "final",
    FULL: "full",
    REFUND: "refund",
    PENALTY: "penalty",
    EXTRA: "extra",
    INSTALLMENT: "installment",
}

/**
 * Тип операции
 * Оплата
 * Возврат
 */
export const OPERATION_TYPE = {
    PAYMENT: "PAYMENT",
    REFUND: "REFUND",
}